import { Pipe, PipeTransform } from "@angular/core";

import { IDisable } from "../interfaces/idisable";

/**
 * Filters the items based toggle switch state and filter
 */
@Pipe({
    name:"disableitemfilter",
    standalone: true
})
export class DisableItemsFilterPipe implements PipeTransform {
    transform(toggleState: boolean, object: IDisable[]): any {
        let filteredObject: Object = object;
        if(object != null && toggleState) {
                filteredObject = object.filter(o => !o.disabled);
        }
        return filteredObject;
    }
}